//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

// This directive is used in table where multiple data are included in a single column.
// In this case a single column can be sorted on either data, depending on which the user selects.
//
// Note: this directive makes the following assumptions in the corresponding HTML due to interaction with ngTable
//  1. The 'title' and 'sortable' attributes passed to ngTable must each be a single string
//     with each option separated by a pipe character
//  2. The ordering of each title and sortable must parallel each other. So the following strings
//          'data-title'="'Username | Followers'"  and  'sortable'="'username | follower_count'"
//     will imply the correspondences 'Username' --> 'username' and 'Followers' --> 'follower_count'
//  3. Because ngTables does not let us interact with a <th> directly this directive is attached by including
//     'data-header'="'/partials/multi-col-header.html'" rather attaching an attribute or class directly

(function() {
  angular.module('curalate').directive('multiColumnHeader', () => ({
    restrict: 'C',
    template: "<span ng-repeat='sort in sorts' " +
                            "ng-click='setSort(sort)' " +
                            "ng-class='{ selected : (sort === currentSort) }'>" +
                            '{{ sort.title }}' +
                      '</span>',
    transclude: false,
    scope: {
      title: '@',
      sortable: '@',
      column: '=',
    },
    controller: ['$scope',
      function($scope) {
        const splitToken = '|';
        const extractSorts = function() {
                            // split input 'title' and 'sortable' strings into paired off sorts
          _.each($scope.title.split(splitToken), (title, i) => {
            $scope.sorts[i] = { 'title': title.trim() };
          });
          _.each($scope.sortable.split(splitToken), (sort, i) => {
            $scope.sorts[i].sort = sort.trim();
          });
        };
        const resetSorts = function() {
                            // Parse out sorts and set initial sort choice
          $scope.sorts = [];
          extractSorts();
          $scope.currentSort = $scope.sorts[0];
        };
                    // Override the sortable function used by ngTable
                    // This function currently returns the 'sortable' attribute attached to each row's <td>
                    // Instead, we hijack set the function to return our current sort
        $scope.column.sortable = function() {
          return $scope.currentSort.sort;
        };
        $scope.setSort = function(sort) {
          $scope.currentSort = sort;
        };

        resetSorts();

                    // Hack to get dynamic titles/sorts working
                    // See https://github.com/bvengineering/pinsights/pull/5338 for an explanation
        $scope.$on('multicolumn:loadNewSorts', (evt, title, sortable) => {
          $scope.title = title;
          $scope.sortable = sortable;
          resetSorts();
        });
      },
    ],
  }));
})();
